// extracted by mini-css-extract-plugin
module.exports = {"form":"_5D2qymzm","text-field":"_5DxG93yk","submit-btn":"_5DrP_d3e","disabled":"_5D2Cgw1T"};